const PURGE_FLAG_KEY = 'ametista-offline-db-purged-v1';

/** Historical Dexie DB names from the removed offline sync layer. */
const LEGACY_DB_NAMES = ['web-offline-db', 'web-offline-dbv1', 'web-offline-dbv2'];

function deleteIndexedDatabase(name: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') {
      resolve();
      return;
    }

    const request = indexedDB.deleteDatabase(name);
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error ?? new Error(`Failed to delete ${name}`));
    // Blocked when another tab still has the DB open — treat as done; next visit retries.
    request.onblocked = () => resolve();
  });
}

/**
 * One-shot purge of legacy offline IndexedDB databases for clients that still have them.
 * Safe to call on every boot; skips after a successful purge is recorded in localStorage.
 */
export async function purgeLegacyOfflineDb(): Promise<void> {
  try {
    if (typeof localStorage !== 'undefined' && localStorage.getItem(PURGE_FLAG_KEY) === '1') {
      return;
    }

    await Promise.all(LEGACY_DB_NAMES.map(deleteIndexedDatabase));

    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(PURGE_FLAG_KEY, '1');
    }
  } catch (error) {
    console.error('Failed to purge legacy offline IndexedDB', error);
  }
}
